import { useUpdateSingleCatalogMutation } from 'Services/ProductManagement/Features/Catalog/catalogApi'
import { productApi, TagTypes } from 'Services/ProductManagement/Features/Product/productApi'
import { useAppDispatch } from 'Store'
import { RTKCacheTags } from 'Util/constants'

export default function useUpdateCatalogProducts() {
  const dispatch = useAppDispatch()
  const [updateSingleCatalog, state] = useUpdateSingleCatalogMutation()

  const updateCatalog: typeof updateSingleCatalog = (...args) => {
    const result = updateSingleCatalog(...args)
    result.unwrap().then(() => {
      dispatch(
        productApi.util.invalidateTags([
          { type: TagTypes.PRODUCT, id: RTKCacheTags.LIST },
          { type: TagTypes.PRODUCT, id: RTKCacheTags.LIST_ALL }
        ])
      )
    })
    return result
  }

  return [updateCatalog, state] as const
}
